import Clarity from "@microsoft/clarity";
import { theme } from "antd";
import ptBR from "antd/es/locale/pt_BR";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import "./App.css";
import { AntdProvider, MobxProvider, stores } from "./config";
import "./config/i18n.config";
import { SocketContext, socket } from "./contexts";
import { ChatProvider } from "./contexts/chat.context";
import { GlobalContextProvider } from "./contexts/global.context";
import SessionContext from "./contexts/session.context";
import { useSessionReducer } from "./reducers";
import Routes from "./routes";
import GlobalStyle from "./styles/global";
import { light } from "./styles/themes";

const CLARITY_CODE = process.env.REACT_APP_CLARITY_CODE;
if (!CLARITY_CODE) throw new Error("A variável de ambiente CLARITY_CODE não foi definida.");

Clarity.init(CLARITY_CODE);

if (process.env.NODE_ENV != "production")
  console.info("Variáveis de ambiente carregadas na inicialização:", process.env);

const root = createRoot(document.getElementById("root") as HTMLElement);

function App() {
  const [sessionState, sessionDispatch] = useSessionReducer();

  const providerState = {
    sessionState,
    sessionDispatch,
  };

  return (
    <GlobalContextProvider>
      <SessionContext.Provider value={providerState}>
        <GlobalStyle />
        <Router>
          <SocketContext.Provider value={socket}>
            <ChatProvider>
              <Routes />
            </ChatProvider>
          </SocketContext.Provider>
        </Router>
      </SessionContext.Provider>
    </GlobalContextProvider>
  );
}

root.render(
  <React.StrictMode>
    <MobxProvider {...stores}>
      <AntdProvider
        locale={ptBR}
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: "#884EA6",
            motion: true,
            borderRadius: 16,
          },
          components: {
            Layout: {
              colorBgHeader: "#FFFFFF",
              colorBgTrigger: "#d1d1d1",
            },
            Typography: {
              colorPrimary: "#884EA6",
            },
            Form: {
              marginLG: 16,
            },
          },
        }}
      >
        <ThemeProvider theme={light}>
          <App />
        </ThemeProvider>
      </AntdProvider>
    </MobxProvider>
  </React.StrictMode>,
);
